module.exports = __webpack_public_path__ + "static/media/d5785bdb.jpg";